import React, { useEffect } from "react";
import "./MedicalCanvassing.css";
import "bootstrap/dist/css/bootstrap.min.css";
import OptionsCards from "../../components/OptionsCards/OptionsCards";
import Vector from "../../assets/Icons/PNG/Vector.png";

export default function MedicalCanvassing({
  selectedMedicalCanvassOptions,
  onMedicalCanvassCheckboxChange,
  setSelectedMedicalCanvassOptions,
  updateLocations,
  selectedLocations,
  onUploadFile,
  uploadedFiles,
  setIsMedicalCanvassingOk,
  formData,
  setFormData,
}) {
  const options = [
    {
      id: 0,
      title: "QuickTel Express Canvass",
      description:
        "QuickTEL canvass is an expedited way to obtain medical checks at 20 facilities in a 70 miles radius of the address provided within 48 hours. Need additional locations? Choose from the below choices",
      features: [
        {
          title: "2 business day turnaround (i.e. 48 hours)",
          isDisabled: false,
        },
        { title: "10 Hospitals", isDisabled: false },
        { title: "10 Pharmacies", isDisabled: false },
      ],
      header: "",
      locations: [],
    },
    {
      id: 1,
      title: "Canvass by Location Type",
      description:
        "Our customer a la carte offering enables you to select as many provider types as you wish to perform a canvass.",
      features: [
        { title: "Select all desired provider locations ", isDisabled: false },
        {
          title: "15 facilities canvassed of each provider type selected",
          isDisabled: false,
        },
      ],
      header: "You must select one Provider Location Type below ",
      locations: selectedLocations,
    },
    {
      id: 2,
      title: "I Do NOT Want a Medical Canvass Completed",
      description: "",
      features: [],
      header: "",
      locations: [],
    },
  ];

  // Auto select second option if any location selected
  useEffect(() => {
    if (!selectedMedicalCanvassOptions?.some((opt) => opt.id === 2)) {
      selectedLocations?.some((location) => location.isSelected) && setSelectedMedicalCanvassOptions(prevState => {
        let updatedState;
        updatedState = prevState.some(item => item.id === 1) ? prevState : [...prevState.filter(opt => opt.id !== 2), options[1]];
  
        return updatedState;
      });
    }
  }, [selectedLocations])

  const canUploadLocationFile = selectedLocations?.some(
    (location) =>
      (location.title === "Psychology" || location.title === "Psychiatric") &&
      location.isSelected
  );

  const isLocationOtherSelected = selectedLocations?.some(
    (location) => location.id === 21 && location.isSelected
  );

  const isLocationOtherTextOk =
    formData.other !== null && formData.other?.trim()?.length > 0;

  const handleLocationsUpdate = (newLocations) => {
    updateLocations(newLocations);
  };

  useEffect(() => {
    (!canUploadLocationFile || selectedMedicalCanvassOptions?.some((opt) => opt.id === 2)) &&
      onUploadFile({ ...uploadedFiles, locationFile: null });
  }, [canUploadLocationFile, selectedMedicalCanvassOptions]);

  useEffect(() => {
    !isLocationOtherSelected &&
      setFormData((prevData) => ({
        ...prevData,
        medicalCanvassing: {
          ...prevData.medicalCanvassing,
          other: "",
        },
      }));
  }, [isLocationOtherSelected]);

  useEffect(() => {
    // No option selected
    if (selectedMedicalCanvassOptions?.length < 1) {
      setIsMedicalCanvassingOk(false);
    }
    // Second option selected
    else if (selectedMedicalCanvassOptions?.some((opt) => opt.id === 1)) {
      // check if there is no selected location(s)
      if (
        selectedLocations.filter((location) => location.isSelected).length < 1
      ) {
        setIsMedicalCanvassingOk(false);
      }
      // check if there is uploaded file(s) in case of selecting one or more of related location(s)
      else if (
        canUploadLocationFile &&
        (uploadedFiles?.locationFile == null ||
          uploadedFiles?.locationFile?.length < 1)
      ) {
        setIsMedicalCanvassingOk(false);
      }
      // check if there is a text in case of selecting 'Other'
      else if (isLocationOtherSelected && !isLocationOtherTextOk) {
        setIsMedicalCanvassingOk(false);
      } else {
        setIsMedicalCanvassingOk(true);
      }
    }
    // First option selected
    else if (selectedMedicalCanvassOptions?.some((opt) => opt.id === 0)) {
      // check if there is uploaded file(s) in case of selecting one or more of related location(s)
      if (
        canUploadLocationFile &&
        (uploadedFiles?.locationFile == null ||
          uploadedFiles?.locationFile?.length < 1)
      ) {
        setIsMedicalCanvassingOk(false);
      }
      // check if there is a text in case of selecting 'Other'
      else if (isLocationOtherSelected && !isLocationOtherTextOk) {
        setIsMedicalCanvassingOk(false);
      } else {
        setIsMedicalCanvassingOk(true);
      }
    }
    // Third option
    else {
      setIsMedicalCanvassingOk(true);
    }
  }, [
    selectedMedicalCanvassOptions,
    selectedLocations,
    uploadedFiles,
    canUploadLocationFile,
    isLocationOtherSelected,
    isLocationOtherTextOk,
  ]);

  return (
    <div>
      <div className="custom-navbar">
        <img src={Vector} alt="Info Icon"></img>
        <h1>PRICING</h1>
        <p className="text-color" id ="pricing-banner">
          After submitting your request, you will receive a confirmation email
          with order details and pricing.
        </p>
      </div>

      <h1 className="txt-orange"id="MedicalCanvassing">Medical Canvassing</h1>
      <p className="p-style">Choose from the following options:</p>
      <div>
        <OptionsCards
          options={options}
          selectedMedicalCanvassOptions={selectedMedicalCanvassOptions}
          onCheckboxChange={(option) => onMedicalCanvassCheckboxChange(option)}
          updateLocations={handleLocationsUpdate}
          formData={formData}
          setFormData={setFormData}
          canUploadLocationFile={canUploadLocationFile}
          isLocationOtherSelected={isLocationOtherSelected}
          isLocationOtherTextOk={isLocationOtherTextOk}
          uploadedFilesNames={
            uploadedFiles?.locationFile?.length > 0
              ? uploadedFiles?.locationFile?.map((file) => file.name)
              : undefined
          }
          onUploadFile={(file) =>
            onUploadFile({
              ...uploadedFiles,
              locationFile: (uploadedFiles?.locationFile?.length > 0
                ? [...uploadedFiles?.locationFile]
                : []
              ).concat([file]),
            })
          }
          onRemoveFile={(index) =>
            onUploadFile({
              ...uploadedFiles,
              locationFile: uploadedFiles?.locationFile?.filter(
                (_, i) => i !== index
              ),
            })
          }
        />
      </div>
    </div>
  );
}
